<template>
  <span>
    <span v-if="cinema?.titleShort" :class="{ 'md:hidden': cinema.titleShort }">
      {{ cinema.titleShort }}
    </span>
    <span :class="{ '<md:hidden': cinema?.titleShort }">
      {{ cinema?.title }}
    </span>
    <template v-if="cinema?.location">
      <br v-if="lineBreak" class="hidden md:inline" />
      <span :class="{ 'md:hidden': lineBreak }"> -&nbsp;</span>
      <span>{{ cinema.location }}</span>
    </template>
  </span>
</template>
<script setup>
defineProps({
  lineBreak: Boolean,
  cinema: {
    default: () => ({}),
    type: Object,
  },
});
</script>
